import { render } from "./Calendar.vue?vue&type=template&id=68a27240"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"
script.render = render

export default script